import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewExtractionsSubscriptionVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewExtractionsSubscription = { __typename?: 'subscription_root', plan_review_requirement_extractions: Array<{ __typename?: 'plan_review_requirement_extractions', id: any, status: string, instructions?: string | null, candidate_count: number, imported_count: number, error_message?: string | null, model_name?: string | null, created_at: any, completed_at?: any | null, user?: { __typename?: 'users', id: string, first_name: string, last_name: string } | null, plan_review_extraction_documents: Array<{ __typename?: 'plan_review_extraction_documents', id: any, file_name: string }>, pending_candidates: { __typename?: 'plan_review_requirement_candidates_aggregate', aggregate?: { __typename?: 'plan_review_requirement_candidates_aggregate_fields', count: number } | null } }> };


export const GetPlanReviewExtractionsDocument = gql`
    subscription getPlanReviewExtractions($jurisdictionId: uuid!) {
  plan_review_requirement_extractions(
    where: {jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: {created_at: desc}
  ) {
    id
    status
    instructions
    candidate_count
    imported_count
    error_message
    model_name
    created_at
    completed_at
    user {
      id
      first_name
      last_name
    }
    plan_review_extraction_documents(order_by: {sort_order: asc}) {
      id
      file_name
    }
    pending_candidates: plan_review_requirement_candidates_aggregate(
      where: {imported_requirement_id: {_is_null: true}, resolution: {_neq: "SKIP"}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewExtractionsSubscription__
 *
 * To run a query within a React component, call `useGetPlanReviewExtractionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewExtractionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewExtractionsSubscription({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetPlanReviewExtractionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPlanReviewExtractionsSubscription, GetPlanReviewExtractionsSubscriptionVariables> & ({ variables: GetPlanReviewExtractionsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPlanReviewExtractionsSubscription, GetPlanReviewExtractionsSubscriptionVariables>(GetPlanReviewExtractionsDocument, options);
      }
export type GetPlanReviewExtractionsSubscriptionHookResult = ReturnType<typeof useGetPlanReviewExtractionsSubscription>;
export type GetPlanReviewExtractionsSubscriptionResult = Apollo.SubscriptionResult<GetPlanReviewExtractionsSubscription>;